module.exports = __webpack_public_path__ + "img/fluke.1b78da52.svg";